import {
  combineReducers
} from 'redux'

const me = (state = {
  partnerStatus: false,
}, action) => {
  switch (action.type) {
    case 'USER_LOGIN_SUCCESS':
      return action.data;
  }
  return state
}

const isLogined = (state = false, action) => {
  switch (action.type) {
    case 'USER_LOGIN_SUCCESS':
    case 'USER_LOGIN_EXTERNAL_SUCCESS':
      return true;
    case 'USER_LOGOUT_SUCCESS':
      return false;
  }
  return state
}

const shirtProfiles = (state = [], action) => {
  if (action.type == 'SIZE_PROFILES_RECEIVED') {
    return action.data.shirtProfile
  }
  return state;
}

const productCart = (state = {}, action) => {
  if (action.type == 'SHIRT_ADDED_TO_CART') {
    return action.data;
  }
  return state;
}

const isAddedToCart = (state = false, action) => {
  if (action.type == 'SHIRT_ADDED_TO_CART') {
    return true;
  }
  if (action.type == 'CART_WIDGET_CLOSE' || action.type == 'UPDATE_SHIRT_RENDER') {
    return false;
  }
  return state;
}


export default combineReducers({
  me,
  shirtProfiles,
  isLogined,
  productCart,
  isAddedToCart,
})
